const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-google-slides'] = {
        c: () => require('partner/modules/moe-google-slides/moe-google-slides.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-google-slides',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-google-slides'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-google-slides|moe-google-slides'] = {
                c: () => require('partner/modules/moe-google-slides/moe-google-slides.view.tsx'),
                cn: '__local__-__local__-moe-google-slides'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };